import PlainButton from '../common/PlainButton';
import { useCallback, useState } from 'react';
import ColorPickerUtil from './ColorPickerUtil';

const ColorPickerDot = ({style = {}, color, onChange, Dyn, colorsArray, size = 24}) => {
    const [colorHex, setColorHex] = useState(color);
    const styles = {
        cursor: 'pointer',
        background: colorHex,
        width: size,
        height: size,
        border: '2px solid',
        borderColor: size <= 12 ? 'transparent' : '#000',
        margin: 0,
        borderRadius: '100%',
        ...style
    }

    const handleClick = useCallback((e) => {
        e.preventDefault();
        const target = e.target;
        const rect = target.getBoundingClientRect();
        const radius = rect.width / 2;
        ColorPickerUtil.show(rect.x + radius, rect.y + radius, radius, color, (color) => {
            if(!color) {
                // Focus on close of color picker
                target.focus();
            } else if(color?.hex) {
                onChange(color);
                setColorHex(color?.hex);
            }
        }, colorsArray, Dyn.preferences.getTheme());
    }, [onChange, Dyn]);

    const getLoc = useCallback((str) => {
        return Dyn.loc( str );
    }, [Dyn]);

    return (
        <PlainButton className="tde-legend-color tde-mx-2"
        aria-label={getLoc('Color picker')}
        style={ styles } onClick={ handleClick }></PlainButton>
    )
};

export default ColorPickerDot;
